export const STAFF_PREFIX = '/staff';

export const isExternalHref = href => /^https?:\/\//i.test(href);

export const DESIGN_STUDIO_PATH = '/design-studio';
export const TRADE_PARTNER_PATH = '/trade-partner';
export const EVENT_FORM_PATH = '/event/form';
export const LOGIN_PATH = '/login';
export const FORGOT_PASSWORD_PATH = '/forgot-password';

export const THE_BRAND_PATH = '/the-brand';
export const OUR_PROCESS_PATH = '/our-process';
export const TRADE_PATH = '/trade';
export const PORTFOLIO_PATH = '/portfolio';

export function portfolioSlugPath(slug) {
  return `${PORTFOLIO_PATH}/${slug}`;
}
export const BOOK_ONLINE_PATH = '/book-online';
export const BOOK_ONLINE_ACTION_PATH = '/book-online/action';
/** Legacy Acuity URL (unused). Internal booker is BOOK_ONLINE_PATH. */
export const BOOK_ONLINE_EXTERNAL_URL = 'https://app.acuityscheduling.com/schedule/12e07076';
export const COLLECTIONS_PATH = '/collections';
export const SUB_COLLECTIONS_PATH = '/sub-collections';

/** Future route once sub-collections are backed by API (e.g. /collections/kitchens/the-limerick). */
export function collectionSubCollectionPath(collectionSlug, subCollectionSlug) {
  return `${COLLECTIONS_PATH}/${collectionSlug}/${subCollectionSlug}`;
}
export const STUDIO_PATH = '/studio';
export const NEWS_PATH = '/news';
export const LOOKBOOKS_PATH = '/lookbooks';
export const PRINT_PATH = '/print';
export const BLOGS_PATH = '/blogs';
export const CAREERS_PATH = '/careers';
export const CONTACT_PATH = '/contact';
export const BOUTIQUE_DEVELOPERS_PATH = '/boutique-development-home-builders';

export function boutiqueDevelopersSlugPath(slug) {
  return `${BOUTIQUE_DEVELOPERS_PATH}/${slug}`;
}
export const PRODUCT_MANUALS_PATH = '/product-manuals';

export function productManualSlugPath(slug) {
  return `${PRODUCT_MANUALS_PATH}/${slug}`;
}
export const DEALERS_PATH = '/dealers';
export const WARRANTY_PDF_PATH = '/pdfs/NIICO%20Millwork%20Limited%20Warranty.pdf';
export const LOOKBOOK_PDF_PATH = '/pdfs/Niico_LookBook.pdf';

function staffPathSuffix(path) {
  if (path.startsWith('/')) return path;
  if (path) return `/${path}`;
  return '';
}

export const staffPath = (path = '') => `${STAFF_PREFIX}${staffPathSuffix(path)}`;

export const staffLoginHref = () => `${LOGIN_PATH}?next=${encodeURIComponent(staffPath())}`;

export function isHomeRoute(pathname) {
  return pathname === '/';
}

export function isStaffRoute(pathname) {
  return pathname.startsWith(STAFF_PREFIX);
}

/** @deprecated Route groups replace _app.js branching; kept for any remaining pages-router code. */
export function isMarketingRoute(pathname) {
  return (
    pathname === '/' ||
    pathname === DESIGN_STUDIO_PATH ||
    pathname === TRADE_PARTNER_PATH ||
    pathname === FORGOT_PASSWORD_PATH ||
    pathname === LOGIN_PATH ||
    pathname === EVENT_FORM_PATH ||
    pathname.startsWith(`${EVENT_FORM_PATH}/`) ||
    pathname === THE_BRAND_PATH ||
    pathname === OUR_PROCESS_PATH ||
    pathname === TRADE_PATH ||
    pathname === PORTFOLIO_PATH ||
    pathname.startsWith(`${PORTFOLIO_PATH}/`) ||
    pathname === BOOK_ONLINE_PATH ||
    pathname.startsWith(`${BOOK_ONLINE_PATH}/`) ||
    pathname === COLLECTIONS_PATH ||
    pathname.startsWith(`${COLLECTIONS_PATH}/`) ||
    pathname.startsWith(`${SUB_COLLECTIONS_PATH}/`) ||
    pathname === STUDIO_PATH ||
    pathname === NEWS_PATH ||
    pathname === LOOKBOOKS_PATH ||
    pathname === PRINT_PATH ||
    pathname === BLOGS_PATH ||
    pathname === CAREERS_PATH ||
    pathname === CONTACT_PATH ||
    pathname === DEALERS_PATH ||
    pathname === BOUTIQUE_DEVELOPERS_PATH ||
    pathname.startsWith(`${BOUTIQUE_DEVELOPERS_PATH}/`) ||
    pathname === PRODUCT_MANUALS_PATH ||
    pathname.startsWith(`${PRODUCT_MANUALS_PATH}/`)
  );
}

export function isMarketingInteriorRoute(pathname) {
  return isMarketingRoute(pathname) && !isHomeRoute(pathname);
}

/** Hero glass form pages that stack and page-scroll below the lg (1200px) breakpoint. */
export function isMarketingFormRoute(pathname) {
  return (
    pathname === DESIGN_STUDIO_PATH ||
    pathname === TRADE_PARTNER_PATH ||
    pathname === FORGOT_PASSWORD_PATH ||
    pathname === LOGIN_PATH ||
    pathname === EVENT_FORM_PATH ||
    pathname.startsWith(`${EVENT_FORM_PATH}/`)
  );
}
